import { css } from '@emotion/css';

export const cameraContainer = css`
  &.MuiDialogContent-root {
    padding: 0 !important;
    overflow: hidden;
    width: 100%;
  }

  position: relative;
  background-color: black;

  .back-btn {
    position: absolute;
    top: 1%;
    left: 1%;
    padding: 1.25rem;
    z-index: 1;
  }

  .camera-wrapper {
    z-index: 0;
    position: absolute;

    display: flex;

    width: 100%;

    top: 0%;
    left: 0%;

    video {
      object-fit: cover;
    }

    .camera-result {
      object-fit: cover;
      width: 100%;
      height: calc(100vh - 36px);
    }

    .camera-placeholder {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: flex;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .camera-trigger-container {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    bottom: 4.5%;
    display: flex;
    align-items: center;
    .camera-trigger {
      padding: 0;
      display: flex;
    }

    .camera-trigger-retry {
      margin-right: 0.625rem;
      text-transform: none;
      color: white;
      font-size: 1rem;
      white-space: nowrap;
    }

    button.ok {
      min-width: 6.25rem;
    }
  }

  .upload-guide-btn {
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: white;
    &:hover {
      background-color: white;
    }
  }
`;
